import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/chineseparkserver/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    save: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/chineseparkserver/edit/save", vo, successCallback, failureCallback);
    }
};

export default EditService;